module.exports = __webpack_public_path__ + "img/200.9ec5432b.png";